export default __webpack_public_path__ + "static/media/chip.a5d8e4d7.mp3";